/**
 * Line icons for the collapsed sidebar and the notification bell: hairline strokes on a 20px grid,
 * like the rest of the Studio. Decorative; the control around each one carries its name.
 */
const PATHS = {
  pages: "M5 3.5h7l3 3v10H5zM12 3.5v3h3M7.5 10h5M7.5 13h5",
  works: "M3 5h14v10H3zM3 8h14M3 12h14M6 5v3M10 5v3M14 5v3M6 12v3M10 12v3M14 12v3",
  media: "M3 4.5h14v11H3zM3 13l4-4 3 3 2.5-2.5L17 14M12.5 8a1 1 0 1 0 0-.01",
  people: "M10 9.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM4 16.5c.8-3 3.2-4.5 6-4.5s5.2 1.5 6 4.5",
  inbox: "M3 11.5 5 4.5h10l2 7v4H3zM3 11.5h4l1 2h4l1-2h4",
  comment: "M3.5 4.5h13v9h-7l-4 3v-3h-2z",
  bell: "M6 13.5V9a4 4 0 0 1 8 0v4.5l1.5 1.5h-11zM8.5 17h3",
  team: "M7.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM2.5 16c.6-2.6 2.6-4 5-4s4.4 1.4 5 4M13 4.2a2.5 2.5 0 0 1 0 4.6M14.5 12.2c1.5.5 2.6 1.8 3 3.8",
  settings: "M4 6h7M15 6h1M4 14h1M9 14h7M13 4v4M7 12v4",
  search: "M9 14.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 13l4 4",
  collapse: "M3.5 4h13v12h-13zM8 4v12M13.5 8l-2 2 2 2",
  expand: "M3.5 4h13v12h-13zM8 4v12M11.5 8l2 2-2 2",
  account: "M10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM4.5 16.5c.7-2.6 2.9-4 5.5-4s4.8 1.4 5.5 4",
  signout: "M8 4H4.5v12H8M12 6.5 15.5 10 12 13.5M15.5 10H8",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, className }: { name: IconName; className?: string }) {
  return (
    <svg viewBox="0 0 20 20" className={`icon ${className ?? ""}`} aria-hidden="true" focusable="false">
      <path d={PATHS[name]} fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
